(function () {
  "use strict";

  const data = getData();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    addStyle();
    addCompareBtnPDP();
    addComparePopup();
    handleEvents();
    assignCssVariables();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.compare-popup.show) {
        overflow: hidden;
      }
      .compare-btn {
        width: 100%;
        margin-bottom: 1rem;
        padding: 12px;
        background: #fff;
        border: 2px solid #7A0000;
        color: #7A0000;
        font-weight: 700;
      }
      .compare-btn:active {
        transform: scale(0.98);
      }
      .compare-popup {
        --nav-height: 0px;
        display: none;
        position: fixed;
        inset: 0;
        width: 100%;
        height: calc(100dvh - var(--nav-height));
        margin-top: var(--nav-height);
        background: #fff;
        overflow: auto;
        z-index: 9999999;
      }
      .compare-popup-close-btn {
        position: fixed;
        top: calc(var(--nav-height) + 1rem);
        right: 1rem;
        display: flex;
        cursor: pointer;
        z-index: 3;
      }
      .compare-popup-close-btn svg {
        width: 30px;
        height: 30px;
      }
      .compare-popup-close-btn:active svg {
        transform: scale(0.95);
      }
      .compare-popup p {
        margin: 0;
      }
      .compare-popup p.title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 28px;
        font-weight: 700;
      }
      .compare-popup p.subtitle {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
      .compare-popup table {
        width: 100%;
        table-layout: fixed;
      }
      .compare-popup table tr {
        background: #fff;
      }
      .compare-popup table tr.row_select {
        position: sticky;
        top: 0;
        z-index: 2;
      }
      .compare-popup table tr.row_info {
        position: sticky;
        top: var(--select-height);
        z-index: 1;
      }
      .compare-popup table tr.row_price {
        position: sticky;
        top: calc(var(--select-height) + var(--info-height));
        z-index: 1;
      }
      .compare-popup table tr.row_cta {
        position: sticky;
        top: calc(var(--select-height) + var(--info-height) + var(--price-height));
        z-index: 1;
      }
      .compare-popup table tr.row_cutoff {
        background: transparent;
      }
      .compare-popup table tr.row_cta {
        box-shadow: 0px 4px 2px -2px #00000040;
      }
      .compare-popup table td {
        padding: 0px 3px;
        vertical-align: middle;
      }
      .compare-popup table tr.row_select td,
      .compare-popup table tr.row_price td,
      .compare-popup table tr.row_cta td,
      .compare-popup table tr.row_cutoff td {
        padding-block: 0.5rem;
      }
      .compare-popup table tr.row_info td {
        vertical-align: top;
      }
      .compare-popup table tr > td:nth-child(3) {
        display: none;
      }
      .compare-popup table .select {
        position: relative;
        width: 100%;
      }
      .compare-popup table .select .trigger {
        display: flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        background-color: #fff;
        border: 1.5px solid #e8e9eb;
        border-radius: 2px;
        padding: 1rem 2rem 1rem 1rem;
        height: 70px;
        font-weight: 600;
      }
      .compare-popup table .select .trigger:after {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/c436165bf05bba37de8351ac6640ef40.svg) no-repeat center;
        background-size: cover;
        width: 14px;
        height: 7px;
        content: "";
      }
      .compare-popup table .select .trigger span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .compare-popup table .select .options {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        left: 0;
        max-height: 320px;
        border-radius: 4px;
        background: #676669;
        padding: 10px 0;
        overflow-y: auto;
        z-index: 1;
      }
      .compare-popup table .select.open .options {
        display: block;
      }
      .compare-popup table .select .options .option {
        position: relative;
        cursor: pointer;
        padding: 3px 42px;
        color: #fff;
        line-height: 1.7;
      }
      .compare-popup table .select .options .option.selected:before {
        display: block;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/85a786792f447dd5bad3b7b35c183ac9.svg) no-repeat center;
        background-size: cover;
        width: 18px;
        height: 17px;
        content: "";
      }
      .compare-popup table .select .options .option:hover {
        background: #4687e9;
      }
      .compare-popup table .row_image img {
        max-height: 250px;
        width: auto;
        display: block;
        margin: 0 auto;
      }
      .compare-popup table .info_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
      .compare-popup table .info_wrapper p:first-child {
        font-size: 14px;
      }
      .compare-popup table .info_wrapper p:nth-child(n+2) {
        font-size: 12px;
      }
      .compare-popup table .price_wrapper {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      .compare-popup table .price_wrapper .price {
        color: #9b0202;
        font-size: 17px;
        font-weight: 700;
      }
      .compare-popup table .price_wrapper .compare_at_price {
        font-size: 13px;
        align-self: flex-end;
      }
      .compare-popup table .cta_wrapper a {
        width: 100%;
        padding: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7a0000;
        background: #7a0000;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
      }
      .compare-popup table .data_wrapper {
        padding-block: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 8px;
      }
      .compare-popup table .data_wrapper img {
        max-width: 120px;
        max-height: 100px;
      }
      .compare-popup table .data_wrapper:empty {
        display: none;
      }
      .compare-popup table .data_wrapper p {
        font-size: 12px;
      }
      @media (min-width: 1024px) {
        .compare-btn {
          position: absolute;
          top: 0;
          right: 0;
          max-width: 180px;
          margin-bottom: 0;
        }
        .compare-popup p.title {
          font-size: 32px;
        }
        .compare-popup p.subtitle {
          font-size: 16px;
        }
        .compare-popup table td {
          padding-inline: 8px;
        }
        .compare-popup table tr > td:nth-child(3) {
          display: table-cell;
        }
        .compare-popup table tr.row_select {
          display: none;
        }
        .compare-popup table tr.row_info {
          top: 0
        }
        .compare-popup table tr.row_price {
          top: var(--info-height);
        }
        .compare-popup table tr.row_cta {
          top: calc(var(--info-height) + var(--price-height));
        }
        .compare-popup table .info_wrapper p:first-child {
          font-size: 20px;
        }
        .compare-popup table .info_wrapper p:nth-child(n+2) {
          font-size: 14px;
        }
        .compare-popup table .price_wrapper .price {
          font-size: 22px;
        }
        .compare-popup table .cta_wrapper a {
          padding: 13px 23px;
          font-size: 16px;
        }
        .compare-popup table .data_wrapper p b {
          font-size: 16px;
        }
        .compare-popup table .data_wrapper img {
          max-width: 200px;
          max-height: 150px;
        }
      }
    `;
    document.head.append(style);
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");
    button.classList.add("btn", "spec-button", "pdp-compare-btn");
    button.textContent = "Compare";
    button.addEventListener("click", function () {
      $(".compare-popup").toggleClass("show");
    });
    $(".nav2-content .spacer").after(button);
  }

  function addComparePopup() {
    const comparePopup = document.createElement("div");
    comparePopup.classList.add("compare-popup");
    comparePopup.innerHTML = `
      <div class="compare-popup-close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/></svg>
      </div>
      <div class="page-width">
        <p class="title">Compare Robot Vacuum</p>
        <p class="subtitle">Discover your perfect cleaning companion choose the right robot vacuum for a smarter, more effortless home.</p>
        <table class="compare-table">
          <tbody></tbody>
        </table>
      </div>
    `;
    document.body.append(comparePopup);

    fillComparePopup(comparePopup);

    return comparePopup;
  }

  function fillComparePopup(comparePopup) {
    const tbody = $(comparePopup).find("table tbody");

    for (const x in [...Array(14).keys()]) {
      const rowIndex = Number(x);
      const row = document.createElement("tr");
      tbody.append(row);

      switch (rowIndex) {
        case 0:
          $(row).addClass("row_select");
          break;
        case 1:
          $(row).addClass("row_image");
          break;
        case 2:
          $(row).addClass("row_info");
          break;
        case 3:
          $(row).addClass("row_price");
          break;
        case 4:
          $(row).addClass("row_cta");
          break;
        case 5:
          $(row).addClass("row_cutoff");
          break;
        default:
          $(row).addClass("row_data");
          break;
      }

      for (const y in [...Array(3).keys()]) {
        const colIndex = Number(y);
        const cell = document.createElement("td");
        row.append(cell);

        const colData = Object.entries(data)[colIndex];
        const prodName = colData[0];
        const prodData = colData[1];

        const prodNames = Object.entries(data).map((x) => x[0]);

        if (rowIndex == 0) {
          cell.innerHTML = `
            <div class="select">
              <div class="trigger">
                <span>${prodName}</span>
              </div>
              <div class="options">
                ${prodNames.map((n, i) => `<div class="option ${colIndex == i ? "selected" : ""}">${n}</div>`).join("")}
              </div>
            </div>
          `;
        } else if (rowIndex == 1) {
          cell.innerHTML = `
            <div class="image_wrapper">
              <img src="${prodData.image_url}" alt="" width="" height="" />
            </div>
          `;
        } else if (rowIndex == 2) {
          cell.innerHTML = `
            <div class="info_wrapper">
              <p>${prodName}</p>
              <p>${prodData.type}</p>
            </div>
          `;
        } else if (rowIndex == 3) {
          cell.innerHTML = `
            <div class="price_wrapper">
              <img width="20" height="20" src="//prismplus.sg/cdn/shop/t/35/assets/voucher-icon.svg?v=96074962922774460831765247161" />
              <span class="price">${theme.Currency.formatMoney(prodData.price)}</span>
              <s class="compare_at_price">${theme.Currency.formatMoney(prodData.compare_at_price)}</s>
            </div>
          `;
        } else if (rowIndex == 4) {
          cell.innerHTML = `
            <div class="cta_wrapper">
              <a href="${prodData.url}">Shop Now</a>
            </div>
          `;
        } else if (rowIndex == 5) {
          cell.innerHTML = ``;
        } else {
          let dataRowCount = rowIndex - 6;
          const filteredDetails = Object.fromEntries(
            Object.entries(prodData.details).filter(
              ([key, value]) => value !== null,
            ),
          );
          const curRow = Object.entries(filteredDetails)[dataRowCount];
          if (curRow) {
            const dKey = curRow[0];
            const dVal = curRow[1];

            const dataWrapper = document.createElement("div");
            dataWrapper.classList.add("data_wrapper", `data-${dKey}`);
            cell.append(dataWrapper);
            dataWrapper.innerHTML = getDetailsHtml(dKey, dVal);
          }
        }
      }
    }
  }

  function handleEvents() {
    const compareBtn = $(".compare-btn");
    const comparePopup = $(".compare-popup");
    const closeBtn = comparePopup.find(".compare-popup-close-btn");
    const select = comparePopup.find(".select");
    const trigger = comparePopup.find(".select .trigger");
    const option = comparePopup.find(".option");

    compareBtn.on("click", function () {
      comparePopup.addClass("show");
    });
    closeBtn.on("click", function () {
      comparePopup.removeClass("show");
    });
    trigger.on("click", function () {
      $(this).closest(".select").toggleClass("open");
    });
    option.on("click", function () {
      $(this).siblings(".option.selected").removeClass("selected");
      $(this).addClass("selected");
      $(this).closest(".select").removeClass("open");

      const prodName = $(this).text();
      $(this).closest(".select").find(".trigger span").text(prodName);

      const prodData = data[prodName];
      const curIndex = $(this).closest("td").index();

      $(`.compare-table .row_info td:nth-child(${curIndex + 1}) .info_wrapper`)
        .html(`
        <p>${prodName}</p>
        <p>${prodData.type}</p>
      `);

      $(`.compare-table .row_image td:nth-child(${curIndex + 1}) img`).attr(
        "src",
        prodData.image_url,
      );

      $(`.compare-table .row_price td:nth-child(${curIndex + 1}) .price`).html(
        theme.Currency.formatMoney(prodData.price),
      );
      $(
        `.compare-table .row_price td:nth-child(${curIndex + 1}) .compare_at_price`,
      ).html(theme.Currency.formatMoney(prodData.compare_at_price));

      $(`.compare-table .row_cta td:nth-child(${curIndex + 1}) a`).attr(
        "href",
        prodData.url,
      );

      const defaultModelDetails = prodData.details;
      const filteredDetails = Object.entries(defaultModelDetails).filter(
        ([key, value]) => value !== null,
      );
      const rowDataCells = $(
        `.compare-table .row_data td:nth-child(${curIndex + 1})`,
      );
      rowDataCells.empty();
      rowDataCells.each(function (i, cell) {
        if (filteredDetails[i]) {
          const dKey = filteredDetails[i][0];
          const dVal = filteredDetails[i][1];

          const dataWrapper = document.createElement("div");
          dataWrapper.classList.add("data_wrapper", `data-${dKey}`);
          dataWrapper.innerHTML = getDetailsHtml(dKey, dVal);
          cell.append(dataWrapper);
        }
      });
    });
  }

  function assignCssVariables() {
    const comparePopup = $(".compare-popup")[0];

    setInterval(() => {
      comparePopup.style.setProperty(
        "--select-height",
        `${$(".compare-table .row_select").height()}px`,
      );
      comparePopup.style.setProperty(
        "--info-height",
        `${$(".compare-table .row_info").height()}px`,
      );
      comparePopup.style.setProperty(
        "--price-height",
        `${$(".compare-table .row_price").height()}px`,
      );
      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }

  function getDetailsHtml(dKey, dVal) {
    let html = ``;

    switch (dKey) {
      case "water":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/nanobot_elite_ai_water_refill.png?v=1776070330" alt="" width="" height="" /><p><b>Auto Water Refill & Detergent Dispensing</b></p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/nanobot_pro_water_refill.png?v=1776070330" alt="" width="" height="" /><p><b>Auto Water Refill</b></p>`;
            break;
          case 3:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/nanobot_water_tank.png?v=1776070330" alt="" width="" height="" /><p><b>Built-In Water Tank</b></p>`;
            break;
        }
        break;
      case "autoDispose":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/nanobot_elite_ai_auto_dispose.png?v=1776070331" alt="" width="" height="" /><p><b>AutoDispose: Self-Emptying Dustbin</b></p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/nanobot_pro_auto_dispose.png?v=1776070330" alt="" width="" height="" /><p><b>AutoDispose: Self-Emptying Dustbin</b></p>`;
            break;
        }
        break;
      case "battery":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/nanobot_battery.png?v=1776070330" alt="" width="" height="" /><p><b>Long-Lasting Battery</b></p>`;
            break;
        }
        break;
      case "autoHairCutting":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AutoHairCutting.svg?v=1776217543" alt="" width="" height="" /><p><b>Auto Hair-Cutting</b><br/>${dVal}</p>`;
        break;
      case "thermoClean":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ThermoClean.svg?v=1776217543" alt="" width="" height="" /><p><b>ThermoClean</b><br/>${dVal}</p>`;
        break;
      case "suctionPower":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SuctionPower.svg?v=1776217543" alt="" width="" height="" /><p><b>Suction Power</b><br/>${dVal}</p>`;
        break;
      case "obstacleClimbing":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Obstacle_Climbing.svg?v=1776217543" alt="" width="" height="" /><p><b>Obstacle Climbing</b><br/>${dVal}</p>`;
        break;
      case "mopArm":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Mop_Arm.svg?v=1776217543" alt="" width="" height="" /><p><b>Mop Arm</b><br/>${dVal}</p>`;
        break;
      case "obstacleDetection":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EliteAiObstacle_Detection.svg?v=1776217543" alt="" width="" height="" /><p><b>Obstacle Detection</b><br/>Advance AI Recognition</p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ProObstacleDetection.svg?v=1776217543" alt="" width="" height="" /><p><b>Obstacle Detection</b><br/>Line Laser Navigation</p>`;
            break;
          case 3:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotObstacleDetection.svg?v=1776217543" alt="" width="" height="" /><p><b>Obstacle Detection</b><br/>IR Obstacle Detection</p>`;
            break;
        }
        break;
    }

    return html;
  }

  function getData() {
    const data = {
      "NanoBot Elite AI": {
        type: "Smart Robot Vacuum",
        url: "/products/prism-nanobot-elite-ai",
        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotEliteAI-Thumb1v2.jpg?v=1773627288",
        price: 69900,
        compare_at_price: 109900,
        details: {
          water: 1,
          autoDispose: 1,
          battery: null,
          autoHairCutting: "Self-Cleaning Roller Brush",
          thermoClean: "60°C Wash & Dry",
          suctionPower: "18,000 Pa",
          obstacleClimbing: "25mm",
          mopArm: "Extended",
          obstacleDetection: 1,
        },
      },
      "NanoBot Pro": {
        type: "Smart Robot Vacuum",
        url: "/products/prism-nanobot-pro",
        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBotPro-Thumb1v2.jpg?v=1773627322",
        price: 44900,
        compare_at_price: 95900,
        details: {
          water: 2,
          autoDispose: 2,
          battery: null,
          autoHairCutting: null,
          thermoClean: "50°C Wash & Dry",
          suctionPower: "15,000 Pa",
          obstacleClimbing: "20mm",
          mopArm: "Extended",
          obstacleDetection: 2,
        },
      },
      NanoBot: {
        type: "Smart Robot Vacuum",
        url: "/products/prism-nanobot",
        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/NanoBot-Thumb1v2.jpg?v=1773627356",
        price: 22900,
        compare_at_price: 61900,
        details: {
          water: 3,
          autoDispose: null,
          battery: 1,
          autoHairCutting: null,
          thermoClean: null,
          suctionPower: "13,000 Pa",
          obstacleClimbing: "18mm",
          mopArm: "TwistMop Edge Mopping",
          obstacleDetection: 3,
        },
      },
    };

    return data;
  }
})();
